import { Box, Button, Grid, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { routes } from "schemas/routes";

import { isPage } from "utils/general";
import { useLogin } from "utils/useLogin";

import { getOnboardingSteps } from "../helper";

interface Props {
  title: JSX.Element | string;
  description?: JSX.Element | string;
  children?: React.ReactNode;
  handleNext?: () => void;
  handleSkip?: () => void;
  handleBack?: () => void;
  nextButtonText?: string;
}

const StyledOnboardingPage = ({
  title,
  description,
  children,
  handleBack,
  handleNext,
  handleSkip,
  nextButtonText = "Next",
}: Props) => {
  const isProfilePage = isPage(routes.profile);
  const isOnboarding = isPage(routes.onboardingInfluencer);
  const isInstagramOnboarding = isPage(routes.onboardingInstagram);
  const location = useLocation();

  const { isSocialFlow, isPaywallFlow } = useLogin();

  const { steps, currentStep } = getOnboardingSteps(
    isSocialFlow,
    isPaywallFlow,
    location.pathname,
  );

  return (
    <>
      {(isOnboarding || isInstagramOnboarding) && currentStep > -1 && (
        <Grid container justifyContent="center">
          <Box
            sx={{
              borderRadius: 20,
              fontWeight: 500,
              border: "1px black solid",
              px: 2,
              py: 1,
              width: "max-content",
              mb: 1,
            }}
          >
            Step {currentStep}/{steps.length}
          </Box>
        </Grid>
      )}

      <Box sx={{ mb: isProfilePage ? 0 : 3 }}>
        <Typography sx={{ textAlign: "center", fontSize: { xs: 20, md: 40 } }}>
          {title}
        </Typography>
        <Typography textAlign={"center"} sx={{ fontSize: 18 }}>
          {description}
        </Typography>
      </Box>

      {isProfilePage ? (
        children
      ) : (
        <Grid container justifyContent={"center"}>
          {children}
        </Grid>
      )}

      {!isProfilePage && (
        <Grid container justifyContent={"space-between"}>
          {handleBack ? (
            <Button onClick={handleBack}>
              <Box
                component="i"
                sx={{ mr: 1 }}
                className="fa-regular fa-circle-arrow-left"
              />{" "}
              Back
            </Button>
          ) : (
            <Box></Box>
          )}

          <Box>
            {handleSkip && (
              <Button sx={{ color: "purple.main" }} onClick={handleSkip}>
                Skip
              </Button>
            )}
            {handleNext && (
              <Button variant="contained" disableElevation onClick={handleNext}>
                {nextButtonText}
                <Box
                  component="i"
                  sx={{ ml: 1 }}
                  className="fa-regular fa-circle-arrow-right"
                />
              </Button>
            )}
          </Box>
        </Grid>
      )}
    </>
  );
};

export default StyledOnboardingPage;
